import React from 'react'
import 'react-responsive-modal/styles.css'
import Modal from 'react-responsive-modal'

const MessageModal = ({open, setOpen, textClass, iconClass, message}) => {
    return (
        <Modal open={open} onClose={()=>{setOpen(false)}}  center={true} showCloseIcon={true}>
            <h2 className={'text-center'}><i className={iconClass + " fa-1"}></i></h2>
            <p className={`fs-9s text-center ${textClass}`}>{message}</p>
        </Modal>
    )
}

export default MessageModal
